import type { AIMessage, Message } from '@/features/ai-chat/types/chat.types';

export default function isAiMessage(message: Message | undefined): message is AIMessage {
  return message?.sender === 'ai';
}
